














import { Component, Vue } from 'vue-property-decorator'
import $api from '../../api';
import { Loading , Notification} from 'element-ui';

@Component
export default class Papers extends Vue{
    private title: string = '';
    private content: string = '';
    private time: string = '';
    private isEnglishContent: boolean = false;

    private mounted() {
        const params = this.$route.params;
        let item: any = params.item || {};
        if(!item.id){
            item = JSON.parse(localStorage.getItem('new-datail-cache') as any) || {};
        }

        if(!item.id){
            this.$router.push("/New");
        } else {
            this.title = item.title;
            let content = item.content;
            this.time = item.time;
            this.isEnglishContent = item.language === "英语";

            this.content = content.replace(new RegExp('net:9000/assets', 'g'), 'net/assets')
        }
    }
    private updated() {
        // console.log(this.$route.params);
    }

    private destroyed(){
        if(localStorage.getItem('new-datail-cache')){
            localStorage.removeItem('new-datail-cache');
        }
    }
}
